module.exports = __webpack_public_path__ + "static/media/ilustration_ok.868c5422.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/illustration/ilustration_ok.svg
// module id = 635
// module chunks = 0